const isHermesApp = userAgent => /hermes/i.test(userAgent);

const isAndroidApp = userAgent => /android/i.test(userAgent) && /_app_/i.test(userAgent);
const isIOSApp = userAgent => /_app_/i.test(userAgent);

const isIOSorAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return isHermesApp(userAgent) || isIOSApp(userAgent) || isAndroidApp(userAgent);
};

module.exports = {
    isHermesApp,
    isIOSorAndroid,
};
